import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { BlastV2Service } from './service/blast-v2.service';
import { SystemService } from '../../../system/system.service';
import { ElasticConfigDTO, MenuDTO, MenuType, TickerConfigDTO } from '../../../system/system-dtos';
import { TickerTableDataSource } from './components/main-table-content-v2/TickerTableDataSource';
import { MainTableV2PaginatorDecoratorComponent } from './components/main-table-v2-paginator-decorator/main-table-v2-paginator-decorator.component';
import { LockService } from './service/lock-service';

@Component({
  selector: 'app-main-table-v2',
  templateUrl: './main-table-v2.component.html',
  styleUrls: ['./main-table-v2.component.scss'],
  standalone: false,
})
export class MainTableV2Component implements AfterViewInit {
  collectionCode: string;

  tableConfig: TickerConfigDTO;

  data: any[];

  dataSource: TickerTableDataSource;

  @ViewChild(MainTableV2PaginatorDecoratorComponent)
  paginator: MainTableV2PaginatorDecoratorComponent;

  archiveConfig: ElasticConfigDTO;

  menuConfig: MenuDTO;

  reloadSubject: Subject<ParamMap> = new BehaviorSubject<ParamMap>(null);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private blastService: BlastV2Service,
    private lockService: LockService,
    private systemService: SystemService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.route.queryParamMap.subscribe((qp) => this.reloadSubject.next(qp));

    this.blastService
      .getRefreshObservable()
      .pipe(
        filter((collectionCode: string) => !!collectionCode && collectionCode === this.collectionCode),
        switchMap((_) => this.route.queryParamMap)
      )
      .subscribe((qm) => this.reloadSubject.next(qm));

    this.reloadSubject
      .pipe(
        switchMap((_) => this.route.paramMap),
        tap((paramMap) => this.setFieldsFromParamMap(paramMap)),
        switchMap((_) => this.systemService.getMenuConfig(this.collectionCode)),
        tap((menuConfig: MenuDTO) => this.setTickerMenuConfig(menuConfig)),
        switchMap((_) => this.blastService.getCollectionObservable(this.collectionCode).pipe(take(1)))
      )
      .subscribe((data) => {
        if (data == null) {
          data = [];
        }
        this.data = data;
        this.loadDataSource(this.tableConfig, this.data);
      });
  }

  private loadDataSource(tableConfig: TickerConfigDTO, data: any[]) {
    if (this.dataSource == null) {
      this.dataSource = new TickerTableDataSource(this.lockService, tableConfig, data);
    } else {
      this.dataSource.reload(tableConfig, data);
    }
    this.changeDetector.detectChanges();
  }

  private setTickerMenuConfig(menuConfig: MenuDTO) {
    this.menuConfig = menuConfig;

    const { dataSources } = menuConfig.entityGroup;

    this.tableConfig = dataSources.find((ds) => ds.type === MenuType.TICKER).definition as TickerConfigDTO;

    this.archiveConfig = dataSources.find((ds) => ds.type === MenuType.ELASTIC)?.definition as ElasticConfigDTO;
  }

  private setFieldsFromParamMap<A>(paramMap: ParamMap) {
    this.collectionCode = paramMap.get('entityCode').split('?')[0];
  }

  navigate() {
    this.router.navigate(['./' + this.menuConfig.code], { relativeTo: this.route.parent });
  }
}
